/** TO BE REMOVED */

export const breakPoints = {
  Large: 1550,
  Laptop: 1279,
  Tablet: 1023,
  Phone: 767,
} as const
